import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IOnlineUseState } from './online-use.state';

export class OnlineUseSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly onlineUseState = (state: IRootState): IOnlineUseState => {
    return state.onlineUse as IOnlineUseState;
  };

  static readonly model = createSelector(OnlineUseSelectors.onlineUseState, (onlineUse: IOnlineUseState) => {
    return onlineUse.model;
  });

  static readonly data = createSelector(OnlineUseSelectors.onlineUseState, (onlineUse: IOnlineUseState) => {
    return onlineUse.data;
  });
}
